/**
 * Shrink-to-fit, used by the game tab title and the break screen's run names. Steps the
 * font size down 1 px at a time until the text stops overflowing, floor 10 px.
 *
 * Needs the web fonts loaded to measure anything meaningful — that is why the tests
 * await document.fonts.ready before asserting on anything it touches.
 */
export const fitText = {
    decreaseFontSizeUntilItFits(element, extraFontDecrease = 0) {
        while (fitText.isElementOverflowing(element)) {
            console.log("Overflowing title: decreasing font size");
            let fontSize = parseInt(window.getComputedStyle(element).fontSize);
            console.log("Current font size:", fontSize);
            element.style.fontSize = (fontSize - 1) + 'px';
            if (fontSize <= 10)
                break;
        }
        if (extraFontDecrease > 0) {
            let fontSize = parseInt(window.getComputedStyle(element).fontSize);
            element.style.fontSize = (fontSize - extraFontDecrease) + 'px';
        }

        element.classList.remove('calculating');
    },

    isElementOverflowing: (element) => {
        return element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
    },

};

window.fitText = fitText;
